import { APIModel } from './api-model.model'
import { APIPermission } from './permission.model'
import { APIRole } from './role.model'

export class APIUser extends APIModel {
    userId: number;
    username: string;
    password: string;
    confirmPassword?: string;
    email: string;
    phone: string;
    providerId: number;
    carrierId: number;
    userEnabled: number;
    roles?: APIRole[];
    permissions?: APIPermission[];
    lastLogin?: string;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        userId: number;
        username: string;
        password: string;
        confirmPassword?: string;
        email: string;
        phone: string;
        providerId: number;
        carrierId: number;
        userEnabled: number;
        roles?: APIRole[];
        permissions?: APIPermission[];
        lastLogin?: string;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })
        this.userId = params.userId
        this.username = params.username
        this.password = params.password
        this.confirmPassword = params.confirmPassword
        this.email = params.email
        this.phone = params.phone
        this.providerId = params.providerId
        this.carrierId = params.carrierId
        this.roles = params.roles
        this.permissions = params.permissions
        this.userEnabled = params.userEnabled ? 1 : 0
        this.lastLogin = params.lastLogin
    }
}
